import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  getWebhookEndpoints,
  IndividualWebhookEndpoint,
} from 'api/admin/businesses/getWebhookEndpoints';

export const useWebhookEndpoints = (businessId: number) => {
  const {
    isLoading,
    error,
    data = [],
    refetch,
  } = useQuery<unknown, AxiosError<{ error: string }>, IndividualWebhookEndpoint[]>({
    queryKey: ['getWebhookEndpoints', businessId],
    queryFn: async () => {
      const response = await getWebhookEndpoints(businessId);
      return response.data?.configs ?? [];
    },
    retry: 1,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching webhook endpoints',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
